import { createContext as e, useState as t, createElement as n, useContext as r, useMemo as o } from "react";

var a = new (function () {
  function e(e) {
    void 0 === e && (e = "__LSM__"), this.name = e, this.state = {}, this.middleWares = [];

    try {
      this.storageType = "undefined" != typeof sessionStorage ? window.sessionStorage : {};
    } catch (e) {
      this.storageType = {};
    }
  }

  var t = e.prototype;
  return t.updateStore = function (e) {
    this.state = function (e, t) {
      try {
        return JSON.parse(e.getItem(t));
      } catch (e) {
        return null;
      }
    }(this.storageType, this.name) || e;
  }, t.updateMiddleWares = function (e) {
    return this.middleWares = e;
  }, e;
}())(),
    i = e(void 0),
    s = function s(e) {
  var r = e.children,
      o = t(a.state);
  return n(i.Provider, {
    value: {
      state: o[0],
      setState: o[1]
    }
  }, r);
};

function _(e, t) {
  var n, r, o;
  void 0 === t && (t = {
    name: "__LSM__",
    middleWares: []
  }), t.name && (a.name = t.name), t.storageType && (a.storageType = t.storageType), t.middleWares && a.updateMiddleWares(t.middleWares), "production" !== process.env.NODE_ENV && (n = a.storageType, r = a.name, o = a.state, "undefined" != typeof window && (window.__LSM__ = r, window.__LSM_NAME__ = r, window.__LSM_DEBUG__ = function (e) {
    return n.setItem("___LSM_DEBUG__", e);
  }, window.__LSM_RESET__ = function () {
    return n.removeItem(r);
  }, window.__LSM_GET_STORE__ = function () {
    return n.getItem(r);
  }, window.__LSM_SAVE_TO__ = function (e) {
    return window.localStorage.setItem(e, JSON.stringify(o));
  }, window.__LSM_LOAD__ = function (e) {
    return n.setItem(r || "___LSM_DEBUG__", e.data || window.localStorage.getItem(e.storeName) || "");
  })), a.updateStore(e);
}

function d(e) {
  var t,
      n = (t = r(i), "production" !== process.env.NODE_ENV && (t || console.error("StateMachine context is undefined, please verify you are calling useStateMachine() as child of a <StateMachineProvider> component.")), t),
      s = n.state,
      _ = n.setState;
  return o(function () {
    return {
      actions: e ? Object.entries(e).reduce(function (e, t) {
        var n;
        return Object.assign({}, e, ((n = {})[t[0]] = function (e, t) {
          return function (n) {
            "production" !== process.env.NODE_ENV && (window.__LSM_NAME__ = t ? t.name : ""), a.state = t(a.state, n), a.storageType.setItem(a.name, JSON.stringify(a.state)), a.middleWares.length && (a.state = a.middleWares.reduce(function (e, r) {
              return r(e, t.name, n) || e;
            }, a.state)), e(a.state);
          };
        }(_, t[1]), n));
      }, {}) : {},
      state: s
    };
  }, [s, _, e]);
}

export { s as StateMachineProvider, _ as createStore, d as useStateMachine };